import { Autocomplete, Box, Chip, IconButton, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import styled from 'styled-components';

export const TableHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: var(--spacing-md) 0;
`;

export const StyledAutocomplete = styled(Autocomplete)`
  width: 30%;
`;

export const RequestCard = styled.div`
  margin-bottom: 20px;
  border-radius: 16px;
  background: #fff;
  padding: 0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition:
    transform 0.15s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  }
`;

export const EditFormWrapper = styled.div`
  overflow: hidden;
  animation: expandDown 0.3s ease-out;
  @keyframes expandDown {
    0% {
      max-height: 0;
      opacity: 0;
      transform: translateY(-10px);
    }
    100% {
      max-height: 1000px;
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const LogoWrapper = styled.div<{ small?: boolean }>`
  width: ${({ small }) => (small ? '24px' : '64px')};
  height: ${({ small }) => (small ? '24px' : '64px')};
  border-radius: ${({ small }) => (small ? '4px' : '8px')};
  background: #f5f5f5;
  display: flex;
  align-items: center;
  margin-right: 8px;
  justify-content: center;
  overflow: hidden;
  position: relative;
`;

export const RequestBox = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fafafa;

  @media (max-width: 600px) {
    gap: 12px;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #e5e5e5;
    background-color: #fff;
  }
`;

export const RequestCompanyName = styled(Typography)`
  flex-grow: 1;
`;

export const ActionButton = styled(IconButton)<{
  $color: string;
  $shadow: string;
}>`
  margin-left: 8px;
  border: 1px solid ${props => props.$color};
  color: ${props => props.$color};
  box-shadow: 0 1px 4px ${props => props.$shadow};
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 6px ${props => props.$shadow};
  }
`;

export const BackButtonWrapper = styled.div`
  margin: var(--spacing-md);
`;

export const FormComponentWrapper = styled.div`
  margin-right: var(--spacing-sm);
`;

// Grid container for displaying author info fields
export const AuthorInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 16px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

// Individual field within the author info grid
export const AuthorInfoField = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: #fafafa;
  border-radius: 4px;

  .label {
    font-weight: 600;
    margin-bottom: 4px;
    color: #333;
  }

  .value {
    color: #555;
  }
`;

export const AuthorInfoSectionWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  padding: var(--spacing-md);
`;

export const AuthorInfoBackButton = styled(Button)`
  margin-bottom: 16px;
`;

export const BtnInner = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  @media (max-width: 720px) {
    justify-content: flex-start;
  }
`;
export const CardRow = styled.div`
  display: grid;
  grid-template-columns: 72px 1fr max-content;
  gap: 16px;
  align-items: center;
  padding: 8px 12px;
  width: 100%;

  @media (max-width: 720px) {
    grid-template-columns: 72px 1fr;
    grid-template-rows: auto auto auto;

    & .actions {
      grid-column: 1 / -1;
      margin-top: 12px;
      justify-self: stretch;
      width: 100%;
    }
    row-gap: 8px;
  }
`;
export const StatusChip = styled(Chip)`
  && {
    height: 32px;
    border-radius: 6px;
    padding: 12px;
    font-size: 12px;
    .MuiChip-icon {
      margin-left: 2px;
    }
  }
`;

export const NameAndStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
`;

export function SectionHeader({ title }: { title: string }) {
  return (
    <Typography variant="h6" sx={{ mb: 1 }}>
      {title}
    </Typography>
  );
}

export const MetaWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  min-width: 0;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const When = styled(Typography)`
  && {
    color: rgba(0, 0, 0, 0.6);
    font-size: 13px;
  }
`;

export const PrettyCard = styled(RequestCard)`
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);
  transition:
    box-shadow 0.25s ease,
    transform 0.2s ease;

  &:hover {
    box-shadow: 0 16px 36px rgba(0, 0, 0, 0.14);
    transform: translateY(-3px);
  }
`;

export const StatusWrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const StatusLabel = styled.span`
  font-weight: 700;
  color: rgba(0, 0, 0, 0.8);
  font-size: 12px;
`;

export const DatePill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.04);
  color: rgba(0, 0, 0, 0.7);
  font-size: 12px;

  @media (max-width: 720px) {
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 4px;
  }
`;

export const Actions = styled.div`
  display: inline-flex;
  gap: 10px;
  align-items: center;
  justify-self: end;
  margin-left: auto;
  white-space: nowrap;

  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 10px;

    & > * {
      width: 100% !important;
    }

    & .MuiButton-root {
      justify-content: flex-start;
      padding: 10px 14px;
    }

    & span {
      justify-content: flex-start;
    }
  }
`;

export const PageHeader = styled.h2`
  display: flex;
  margin-bottom: 24px;
`;

export const MarginBottom = styled.div`
  margin-bottom: var(--spacing-md);
`;
